import React, {useEffect} from 'react'
import Drawer from './drawer'
import HelpDrawer from './help-drawer'
import * as PropTypes from 'prop-types'
import Button from '@retracedgmbh/ui-components-lib/Button'

const HelpButtonAction = ({text, size, style, hideButton, openDrawer, handleDrawerClosed, articleId}) => {
  const [isHelpDrawerOpen, setIsHelpDrawerOpen] = React.useState(false)

  useEffect(() => {
    if (openDrawer == true) {
      setIsHelpDrawerOpen(true)
    }
  }, [openDrawer])

  return (
    <>
      {hideButton ? null : (
        <div className="w-full" style={{display: 'flex', flexDirection: 'row-reverse'}}>
          <Button
            type="button"
            variant="text"
            color="primary"
            size={size || 'md'}
            icon="fa-solid fa-circle-question"
            iconPosition="left"
            isLoading={isHelpDrawerOpen}
            loadingText="Fetching your article"
            title={text}
            style={style}
            onClick={() => setIsHelpDrawerOpen(true)}
          />
        </div>
      )}

      <Drawer
        isFlexibleWidth
        overflowY="scroll"
        isOpen={isHelpDrawerOpen}
        onClose={() => {
          setIsHelpDrawerOpen(false)
          if (handleDrawerClosed) {
            handleDrawerClosed()
          }
        }}
      >
        {isHelpDrawerOpen && <HelpDrawer articleId={articleId} />}
      </Drawer>
    </>
  )
}

HelpButtonAction.propTypes = {
  text: PropTypes.string.isRequired,
  articleId: PropTypes.string.isRequired,
  size: PropTypes.string,
  style: PropTypes.object,
  hideButton: PropTypes.bool,
  openDrawer: PropTypes.bool,
  handleDrawerClosed: PropTypes.func,
}

export default HelpButtonAction
